module.exports = {
  GITHUB_URL:
    'https://api.github.com/repos/royledford/front-end-interview-handbook/readme',
}



// WEBPACK FOOTER //
// ./src/settings.js